import PropTypes from 'prop-types';
import React from 'react';
import {
  ButtonGroup,
  Button,
  Modal,
} from 'react-bootstrap';
import BidDetail from './BidDetail';
import HotelFeedbackLink from './HotelFeedbackLink';

class BidDetailModal extends React.Component {

  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div>
        <Modal bsSize="large" show={this.props.show} onHide={this.props.onClose}>
          <Modal.Header closeButton>
            <Modal.Title>
            Hotel Bid Detail: {this.props.bid.hotel.name}
            ({this.props.bid.bidset.event.group_name})</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <BidDetail
              bid={this.props.bid}
              editBid={this.props.editBid}
              addBidNote={this.props.addBidNote}
              sendBid={this.props.sendBid}
              removeBid={this.props.removeBid}
              isTourManager={this.props.isTourManager}
              readOnly={this.props.readOnly}
              user={this.props.user}
            />
          </Modal.Body>
          <Modal.Footer >
            <HotelFeedbackLink id={this.props.bid.hotel.id} />
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}


BidDetailModal.propTypes = {
  bid: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  editBid: PropTypes.func.isRequired,
  addBidNote: PropTypes.func.isRequired,
  sendBid: PropTypes.func.isRequired,
  removeBid: PropTypes.func.isRequired,
  isTourManager: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
};

BidDetailModal.defaultProps = {
  proposal: {
    contacts: [],
    bids: [],
  },
};
export default BidDetailModal;



// WEBPACK FOOTER //
// src/routes/tours/components/BidDetailModal.js